import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert
} from 'day8-react/build/new-components';
import { Input, Select } from 'day8-ui';
import { countries } from 'countries-list';

const countryList = Object.entries(countries)
  .map(([countryCode, countryData]) => ({ value: countryCode, text: countryData.name }))
  .sort((a, b) => (a.text > b.text) ? 1 : -1);

const EditAddressSection = ({
  userFormData,
  onChange,
  notifications = {},
  hideNotification,
  fieldErrors = {},
  loading
}) => (
  <div className="grid grid-gap-md margin-top-md margin-bottom-xl">
    <div className="col-12">
      <h3 className="yw-app-h3 dui-my-2">Address</h3>
    </div>
    <div className="col-12 col-6@sm" data-account-edit-field="city">
      <Input
        label="CITY*"
        type="text"
        name="city"
        placeholder="City name"
        value={userFormData.city}
        onChange={onChange}
        errorMessage={fieldErrors.city || (notifications.error && notifications.error.city?.notificationMessage)}
      />
    </div>
    <div className="col-12 col-6@sm" data-account-edit-field="country">
      <Select
        label="COUNTRY*"
        defaultLabel={"Choose your country..."}
        options={countryList}
        value={userFormData.country || ""}
        onChange={onChange}
        className='dui-max-w-full'
        name="country"
        errorMessage={fieldErrors.country || (notifications.error && notifications.error.country?.notificationMessage)}
      />
    </div>
    <div className="col-12 col-6@sm" data-account-edit-field="address">
      <Input
        label="ADDRESS*"
        type="text"
        name="address"
        placeholder="Enter your address"
        value={userFormData.address}
        onChange={onChange}
        errorMessage={fieldErrors.address || (notifications.error && notifications.error.address?.notificationMessage)}
      />
    </div>
    <div className="col-12 col-6@sm" data-account-edit-field="zip">
      <Input
        label="ZIP / POST CODE*"
        type="text"
        name="zip"
        placeholder="Zip / post code"
        value={userFormData.zip}
        onChange={onChange}
        errorMessage={fieldErrors.zip || (notifications.error && notifications.error.zip?.notificationMessage)}
      />
    </div>
    <div className="col-12 dui-border-t-[3px] dui-border-solid dui-border-primary-950 dui-pt-6">
      <button
        type="submit"
        disabled={loading}
        className="yw-app-btn"
        style={{ height: 54, width: 'auto', padding: '0 40px', opacity: loading ? 0.7 : 1 }}
      >
        {loading ? 'Saving…' : 'Save profile'}
      </button>
    </div>
    {notifications.success && (
      <Alert
        show={notifications.success.showNotification}
        text={notifications.success.notificationMessage}
        onClose={hideNotification}
        type={notifications.success.notificationType}
      />
    )}
    {notifications.error && (
      <Alert
        show
        type="warning"
        onClose={hideNotification}
      >
        {notifications.error.summaryMessage || fieldErrors._form || 'Please correct the errors above.'}
      </Alert>
    )}
  </div>
);

export default EditAddressSection;

EditAddressSection.propTypes = {
  userFormData: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  hideNotification: PropTypes.func,
  notifications: PropTypes.object,
  fieldErrors: PropTypes.object,
  loading: PropTypes.bool
};
